'use strict';
var getBuiltIn = require('../internals/get-built-in');

module.exports = getBuiltIn('document', 'documentElement');



// WEBPACK FOOTER //
// ./~/core-js/internals/html.js